<template>
    <div class="editform">
        <Form ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100"
            style="margin-left: 60px;margin-top: 20px">
            <FormItem label="原始密码"
                prop="oldPwd">
                <Input v-model="info.oldPwd"
                    type="password"
                    style="width: 300px"
                    :maxlength="30"></Input>
                <Icon type="ios-checkmark-circle"
                    style="color: green;margin-left: 20px"
                    size="15"
                    v-if="showOldPwdTrue" />
                <Icon type="ios-close-circle"
                    style="color: red;margin-left: 20px"
                    size="15"
                    v-if="showOldPwdFalse" />
            </FormItem>
            <FormItem label="输入新密码"
                prop="newPwd">
                <Input v-model="info.newPwd"
                    type="password"
                    style="width: 300px"
                    :maxlength="30"></Input>
                <Icon type="ios-checkmark-circle"
                    style="color: green;margin-left: 20px"
                    size="15"
                    v-if="showNewPwdTrue" />
                <Icon type="ios-close-circle"
                    style="color: red;margin-left: 20px"
                    size="15"
                    v-if="showNewPwdFalse" />
            </FormItem>
            <FormItem label="重复新密码"
                prop="repeatPwd">
                <Input v-model="info.repeatPwd"
                    type="password"
                    style="width: 300px"
                    :maxlength="30"></Input>
                <Icon type="ios-checkmark-circle"
                    style="color: green;margin-left: 20px"
                    size="15"
                    v-if="showRepeatPwdTrue" />
                <Icon type="ios-close-circle"
                    style="color: red;margin-left: 20px"
                    size="15"
                    v-if="showRepeatPwdFalse" />
            </FormItem>
        </Form>
        <p style="color: red;font-size: 14px;margin-top: 50px;margin-left: 90px">注意：密码6-30个字符,必须同时包含字母,数字和特殊符号
        </p>
        <p style="color: red;font-size: 14px;margin-left: 90px">示例：guest123@yuzhi</p>
    </div>
</template>
<script>
import { validOldPwd, updateOnwerPwd } from '@/api/sys-user'
import md5 from 'md5'

const passwordReg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&.])[A-Za-z\d$@$!%*#?&.]{6,30}$/

export default {
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },
    inject: {
        $modal: {
            default: null
        }
    },
    data() {
        return {
            info: {
                oldPwd: '',
                newPwd: '',
                repeatPwd: ''
            },
            showOldPwdTrue: false,
            showOldPwdFalse: false,
            showNewPwdTrue: false,
            showNewPwdFalse: false,
            showRepeatPwdTrue: false,
            showRepeatPwdFalse: false
        }
    },

    computed: {
        ruleValidate() {
            var rules = {
                oldPwd: [{
                        required: true,
                        message: '原始密码必填',
                        trigger: 'blur'
                    },
                    {
                        validator: this.checkOldPwd,
                        trigger: 'blur'
                    }
                ],
                newPwd: [{
                    required: true,
                    message: '新密码必填',
                    trigger: 'blur'
                }, {
                    validator: this.checkNewPwd,
                    trigger: 'blur'
                }],
                repeatPwd: [{
                        required: true,
                        message: '重复新密码必填',
                        trigger: 'blur'
                    },
                    {
                        validator: this.checkRepeatPwd,
                        trigger: 'blur'
                    }
                ]
            }
            return rules
        }
    },
    methods: {
        checkOldPwd(rule, value, callback, source, options) {
            // 排除空值
            if (value == "" || value == null || value == undefined) {
                return callback()
            }
            return validOldPwd(md5(this.info.oldPwd))
                .then(res => {
                    this.showOldPwdTrue = true
                    this.showOldPwdFalse = false
                }, err => {
                    this.showOldPwdTrue = false
                    this.showOldPwdFalse = true
                })
            return callback()
        },
        checkRepeatPwd(rule, value, callback, source, options) {
            // 排除空值
            if (value == "" || value == null || value == undefined) {
                return callback()
            }
            var newPassword = this.info.newPwd
            if (newPassword == "" || newPassword == null || newPassword == undefined) {
                return callback()
            } else {
                if (value == newPassword) {
                    this.showRepeatPwdFalse = false
                    this.showRepeatPwdTrue = true
                } else {
                    this.showRepeatPwdFalse = true
                    this.showRepeatPwdTrue = false
                    this.$Message.error('新密码输入不一致,请重新输入')
                }
            }
            return callback()
        },

        checkNewPwd(rule, value, callback, source, options) {
            var msg = "请输入正确格式的密码"
            // 排除空值
            if (value == "" || value == null || value == undefined) {
                return callback()
            }
            if (typeof value != "string" || passwordReg.test(value) == false) {
                this.showNewPwdTrue = false
                this.showNewPwdFalse = true
                return callback(new Error(msg))
            } else {
                this.showNewPwdFalse = false
                this.showNewPwdTrue = true
            }

            var repeatPassword = this.info.repeatPwd
            if (repeatPassword == '' || repeatPassword == null || repeatPassword == undefined) {
                return callback()
            } else {
                if (value == repeatPassword) {
                    this.showRepeatPwdFalse = false
                    this.showRepeatPwdTrue = true
                } else {
                    this.showRepeatPwdFalse = true
                    this.showRepeatPwdTrue = false
                    this.$Message.error('新密码两次输入不一致,请重新输入')
                }
            }
            return callback()
        }
    },
    mounted() {
        var $info = this.$refs.info
        this.$modal.onBtnClick("confirm", (next, options) => {
            $info.validate(valid => {
                if (valid) {
                    updateOnwerPwd(md5(this.info.newPwd))
                        .then(res => {
                            this.$Message.success(this.$t("tips.update.success"))
                        }, err => options.closeModal = false)
                        .then(res => next())
                } else {
                    options.closeModal = false
                    next()
                }
            })
        })
    }
}
</script>